import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=7e8e1c28&scoped=true&"
var script = {}
import style0 from "./RegistrationModal.vue?vue&type=style&index=0&id=7e8e1c28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8e1c28",
  null
  
)

export default component.exports